/* Atelier - product page: moves the post-purchase content into the full-width band.

   The bundle widget, the description and the reviews widget are all children of Dawn's
   .product__info-container. Two of the three are injected by the Vitals app at runtime,
   so this cannot be done in Liquid - the nodes do not exist when the page is rendered.

   What it does: builds one band element after the buying grid, then relocates those three
   blocks into it. Relocating rather than cloning keeps every event handler the app
   attached, so the bundle's Add to cart and the review pagination keep working.

   Two observers, because Vitals anchors its widgets to the DESCRIPTION, not to a fixed
   container. Once the description moves into the band, Vitals starts injecting into the
   band as well - measured: the bundle and the reviews both landed inside the description's
   own section. So the band is watched too, and anything found in the wrong section is
   re-homed on the next tick.

   The reveal animation lives in atelier-pdp-reveal.js. */
(function () {
  'use strict';

  var SLOTS = [
    { key: 'bundle',  sel: '.vtl-ub-pb-main-widget' },
    { key: 'story',   sel: '.product__description' },
    { key: 'reviews', sel: '.vtl-pr-main-widget--product-page' }
  ];

  var band = null;
  var inner = null;

  function build() {
    if (band && document.contains(band)) return band;

    var product = document.querySelector('.product');
    if (!product) return null;

    /* .product sits inside a .page-width wrapper inside the section. The band goes after
       that wrapper so it is still inside the product section, above related products. */
    var wrapper = product.parentElement;
    if (!wrapper || !wrapper.parentNode) return null;

    band = document.createElement('div');
    band.className = 'gf-pdp-band';

    inner = document.createElement('div');
    inner.className = 'page-width gf-pdp-band__in';
    band.appendChild(inner);

    SLOTS.forEach(function (s) {
      var sec = document.createElement('section');
      sec.className = 'gf-pdp-band__sec gf-pdp-band__sec--' + s.key;
      sec.setAttribute('data-band', s.key);
      sec.hidden = true;
      inner.appendChild(sec);
    });

    wrapper.parentNode.insertBefore(band, wrapper.nextSibling);
    return band;
  }

  /* The bundle and the reviews widget render their own titles. The description's title
     comes from Vitals' product tabs, which wrap it in "Description" / "Shipping
     Information" accordions - when Vitals is serving. It was returning 401 during this
     build, and with the tabs absent the description arrives as bare prose under the
     gallery, so it gets a heading only in that case. Re-checked on every pass, so the
     heading appears and disappears with the app rather than doubling up on it. */
  function storyHeading(slot) {
    var existing = slot.querySelector('.gf-pdp-band__head');

    if (slot.querySelector('.vt-accordion')) {
      if (existing) existing.remove();
      return;
    }
    if (existing || !slot.querySelector('.product__description')) return;

    var head = document.createElement('div');
    head.className = 'gf-pdp-band__head';

    var h = document.createElement('h2');
    h.className = 'gf-pdp-band__h';
    h.textContent = 'Details';

    var rule = document.createElement('hr');
    rule.className = 'gf-pdp-band__rule';

    head.appendChild(h);
    head.appendChild(rule);
    slot.insertBefore(head, slot.firstChild);
  }

  function arm() {
    if (window.AtelierBandReveal) window.AtelierBandReveal.arm();
  }

  function sync() {
    var b = build();
    if (!b) return 0;

    var moved = 0;

    SLOTS.forEach(function (s) {
      var slot = b.querySelector('[data-band="' + s.key + '"]');
      if (!slot) return;

      /* Searched document-wide on purpose: the node may be in the info container, or in
         another band section that Vitals injected it into. */
      var node = document.querySelector(s.sel);
      if (node && node.parentElement !== slot) {
        slot.appendChild(node);
        moved++;
      }

      if (s.key === 'story') storyHeading(slot);

      slot.hidden = !slot.querySelector(s.sel);
    });

    if (moved) {
      /* Vitals sizes its review masonry from the container it measured at render time.
         The containers just changed width, so give it the event it listens for. */
      window.setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
      }, 60);
    }

    return moved;
  }

  function watch() {
    var pending = null;

    function tick() {
      if (pending) return;
      pending = window.setTimeout(function () {
        pending = null;
        if (sync()) arm();
      }, 140);
    }

    var mo = new MutationObserver(tick);

    var info = document.querySelector('.product__info-container');
    if (info) mo.observe(info, { childList: true });

    /* subtree, because a widget injected next to the description lands one level deeper
       than the section itself. A move made here re-triggers this observer once and then
       settles, since the second pass finds nothing out of place. */
    if (inner) mo.observe(inner, { childList: true, subtree: true });
  }

  function start() {
    sync();
    arm();
    watch();
    /* Vitals injects late and in stages; these catch the widgets that are not in the DOM
       on the first pass without leaving a polling loop running. */
    [400, 1200, 2600, 5000, 9000].forEach(function (ms) {
      window.setTimeout(function () { if (sync()) arm(); }, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();